export default __webpack_public_path__ + "static/mobile-home-demolition-icon-c803bb2cf55d9ce7abefb297e4e0037a.png";